(function(){

  'use strict';

    //*****************//
    // Data that this directive needs
    // -----------------
    //
    //*****************//

    // selectDataObject = {
    //   // REQUIRED
    //   listRaw: 'array of object. Either a formated {name: value, id: value} or unformatted (item.info._links.self.href) structure',
    //   placeholderText: 'caption',
    //   // OPTIONAL
    //   label: string,
    //   contextObject: 'optional object that works together with contextMethod',
    //   contextMethod: 'this is the name of the method that we want executed on the contextObject',
    //   linkPath: 'this is used to find the selectedItem in then contextObject',
    //
    //   NOTE
    //   The required data can also be nested in an object like...
    //   selectDataObject.selectDataObject {
    //      keyIdentifier: string, // this should be identical with keyIdentifier in the directive, that this directive is supposed to coorperate with
    //
    //   }
    //   This method is used when the select is supposed to work together with another directive
    // }

  function pxSelect(toastr, $filter) {
    return {
      restrict: 'EA',
      scope: {
        selectDataObject: '=selectDataObject', // See documentation above!!!
        customClass: "=customClass",
        callback: '&callback',
        selectById: '=selectById',
        selectedItemDirect: '=selectedItemDirect',
        ngDisabled: '=ngDisabled'
      },
      templateUrl: 'app/directives/selectDirective/select.template.html',
      link: function(scope) {

        var listRaw = null;
        var contextObject = null;
        var linkPath = null;
        var contextMethod = null;
        var keyIdentifier = null;
        scope.placeholder = null;
        scope.label = null;
        scope.skipOrderByName = scope.selectDataObject.skipOrderByName ? scope.selectDataObject.skipOrderByName : false;

        (function(){
          setVariables();
          if (!validateListRawFormat(listRaw)) {
            createListForSelect();
          }
          getSelectedItem();
        })();

        function setVariables() {
          if (scope.selectDataObject.selectDataObject) {
            listRaw = scope.selectDataObject.selectDataObject.listRaw;
            contextObject = scope.selectDataObject.selectDataObject.contextObject;
            linkPath = scope.selectDataObject.selectDataObject.linkPath;
            contextMethod = scope.selectDataObject.selectDataObject.contextMethod;
            keyIdentifier = scope.selectDataObject.selectDataObject.keyIdentifier;
            scope.placeholder = scope.selectDataObject.selectDataObject.placeholderText;
            scope.label = scope.selectDataObject.selectDataObject.label;
          } else {
            listRaw = scope.selectDataObject.listRaw;
            contextObject = scope.selectDataObject.contextObject;
            linkPath = scope.selectDataObject.linkPath;
            contextMethod = scope.selectDataObject.contextMethod;
            scope.placeholder = scope.selectDataObject.placeholderText;
            scope.label = scope.selectDataObject.label;
          }

          if (scope.selectDataObject.selectedItem) {
            scope.selectedItem = scope.selectDataObject.selectedItem;
          }

          if (scope.selectDataObject.selectedItem) {
            if (scope.selectDataObject.selectedItem.info) {
              scope.selectDataObject.selectedItem.info.name = $filter('translate')(scope.selectDataObject.selectedItem.info.name);
              scope.selectedItem = scope.selectDataObject.selectedItem.info;
            } else {
              scope.selectDataObject.selectedItem.name = $filter('translate')(scope.selectDataObject.selectedItem.name);
              scope.selectedItem = scope.selectDataObject.selectedItem;
            }
          }

          if (scope.selectedItemDirect) {
            scope.selectedItem = scope.selectedItemDirect;
          }
        }

        //*****************//
        // validateListRawFormat()
        // -----------------
        // Checks to see if the provided list needs formating, if not (then skip the next step)
        //*****************//
        function validateListRawFormat(listRaw) {
          if (listRaw[0].name && listRaw[0].id) {
            scope.simplifiedItemsList = translateItemName(listRaw);
            return true;
          }
          return false;
        }

        function translateItemName(listRaw) {
          for (var i = 0; i < listRaw.length; i++) {
            listRaw[i].name = $filter('translate')(listRaw[i].name);
          }
          return listRaw;
        }


        //*****************//
        // createListForSelect()
        // -----------------
        // Maps the raw list to a simplified list that is easier to handle in ui-select
        //*****************//
        function createListForSelect() {
          var itemsListTemp = [];

          for (var i = 0; i < listRaw.length; i++) {
            var item = {};
            item['name'] = listRaw[i].info.name;
            item['id'] = listRaw[i].info._links.self.href;
            itemsListTemp.push(item);
          }

          scope.simplifiedItemsList = translateItemName(itemsListTemp);
        }


        //*****************//
        // getSelectedItem()
        // -----------------
        // Finds the selectedItemRaw in the contextObject and maps it to the simplifiedItemsList
        //*****************//
        function getSelectedItem() {
          var selectedItemRaw = null;
          if (contextObject) {
            if (contextObject && contextObject.info._links[linkPath] && contextObject.info._links[linkPath].href) {
              selectedItemRaw = listRaw.findElement({ info: { _links: { self: { href: contextObject.info._links[linkPath].href } } } });
            } else if (contextObject.info && contextObject.info.userAppSettings && contextObject.info.userAppSettings.lastUsedNetwork) {
              selectedItemRaw = listRaw.findElement({ info: { _links: { self: { href: contextObject.info.userAppSettings.lastUsedNetwork } } } });
              scope.callback({item: selectedItemRaw});
            }
          }

          if (selectedItemRaw) {
            mapItemRawToSimplifiedItemsList(selectedItemRaw);
          }
        }

        function mapItemRawToSimplifiedItemsList (selectedItemRaw) {
          for (var i = 0; i < scope.simplifiedItemsList.length; i++) {
            if (selectedItemRaw.info._links.self.href === scope.simplifiedItemsList[i].id) {
              scope.selectedItem = scope.simplifiedItemsList[i];
            }
          }
        }

        //*****************//
        // changeItem()
        // -----------------
        // Maps the selected simpleItem back to itemRaw format and calls the desired method on the contextObject
        //*****************//
        scope.changeItem = function (simpleItem) {
          var item = mapSimpleItemToItemRaw(simpleItem);
          if (item && contextMethod) {
            contextObject[contextMethod](item).then(function(){
              toastr.success($filter("translate")("ChangesSaved"));
            }).catch(function(error){});
          } else {
            if (keyIdentifier) {
              item.keyIdentifier = keyIdentifier;
              scope.callback({item: item});
            } else {
              scope.callback({item: item});
            }
          }
        }

        function mapSimpleItemToItemRaw (simpleItem) {
          for (var i = 0; i < listRaw.length; i++) {
            if (listRaw[i].info) {
              if (simpleItem.id === listRaw[i].info._links.self.href) {
                return listRaw[i];
              }
            } else {
              return simpleItem;
            }
          }
        }


      }
    };
  }

  pxSelect.$inject = ['toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxSelect', pxSelect);

})();
